import React, { useEffect, useState } from "react";
import { Grid, Button, Alert } from "tabler-react";
import ReactModal from "react-modal";

import { alertCustomStyles } from "../../helpers";
import { ContentTextProps } from "../../types";

import ServerSidePagination from "../../components/pagination/serverSidePagination";
import TableCard from "../../components/tableCard";
import TableModal from "./tableModal";

import "./style.css";

const AutomationCategories = ({
  data,
  loading,
  createIceBreaker,
  deleteIceBreaker,
  updateIceBreaker,
  onPageNumberChange,
}: any): JSX.Element => {
  const [iceBreakerList, setIceBreakerList] = useState<any>([]);

  const [dataLoading, setDataLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [editCategory, setEditCategory] = useState<any>(false);
  const [total, setTotal] = useState(0);
  const [editField, setEditField] = useState<any>(null);

  const handleModal = () => {
    if (showModal) {
      setEditField(null);
      setErrorMessage("");
    }
    setShowModal(!showModal);
  };

  const handleSave = async ({ ...rest }) => {
    const { text } = rest;
    if (editCategory) {
    } else {
      const res = await createIceBreaker({
        variables: { settings: { category: "GENERAL", body: text } },
      });
      if (res.data.HexosparkAdminOps && !res.data.HexosparkAdminOps.createIceBreaker.error_code) {
        handleModal();
        return;
      }
      const { error_code } = res.data.HexosparkAdminOps.createIceBreaker;
      if (error_code) {
        setErrorMessage(error_code);
        return;
      }
    }
    return true;
  };

  const onDelete = async (id: number) => {
    let deleteConfirm = confirm(`Are you sure you want to delete ice breaker with ID: ${id}`);
    if (!deleteConfirm) return;
    const res = await deleteIceBreaker({
      variables: { settings: { ids: [id] } },
    });
    if (res.data.HexosparkAdminOps && !res.data.HexosparkAdminOps.deleteIceBreaker) {
      setIceBreakerList(iceBreakerList.filter((item) => item.id !== id));
      return;
    }
    const { error_code } = res.data.HexosparkAdminOps.deleteIceBreaker;
    if (error_code) {
      setErrorMessage(error_code);
      return;
    }
  };
  const onUpdate = async ({ id, body, category }) => {
    const res = await updateIceBreaker({
      variables: { settings: { id, body, category } },
    });
    handleModal();
    if (res.data.HexosparkAdminOps && !res.data.HexosparkAdminOps.updateIceBreaker) {
      const newCategories = iceBreakerList.map((item) => {
        if (item.id === id) {
          return { ...item, body };
        }
        return item;
      });
      setIceBreakerList(newCategories);
      return;
    }
    const { error_code } = res.data.HexosparkAdminOps.updateIceBreaker;
    if (error_code) {
      setErrorMessage(error_code);
      return;
    }
  };

  const tableData = {
    tData:
      iceBreakerList &&
      iceBreakerList.map((item: ContentTextProps) => ({
        id: item.id,
        body: item.body,
        Action: (
          <Button.List>
            <Button
              color="primary"
              icon="edit"
              onClick={() => {
                setEditField(item);
                setShowModal(true);
              }}
            />
            <Button color="danger" icon="trash" onClick={() => onDelete(item.id)} />
          </Button.List>
        ),
      })),
  };

  useEffect(() => {
    if (data && data.HexosparkAdmin && data.HexosparkAdmin.getCrmIceBreakersAdmin.result) {
      setDataLoading(loading);
      setIceBreakerList(data.HexosparkAdmin.getCrmIceBreakersAdmin.result);
      // setTotal(data.EmailBlackList.adminGetMany.total)
    }
  }, [data]);

  return (
    <Grid.Row cards deck>
      <TableModal
        handleModal={handleModal}
        showModal={showModal}
        onUpdate={onUpdate}
        onSave={handleSave}
        editField={editField}
        errorMessage={errorMessage}
      />

      <ReactModal isOpen={!!errorMessage} style={alertCustomStyles}>
        {errorMessage ? <Alert type="danger">{errorMessage}</Alert> : null}
        <Button className="" onClick={() => setErrorMessage("")} color="primary">
          OK
        </Button>
      </ReactModal>
      <div className="col-12 col-md-1 col-xs-6">
        <Button className="" onClick={() => setShowModal(true)} color="primary">
          Create
        </Button>
        <br />
      </div>
      <Grid.Col md={9}></Grid.Col>
      <div className="col-12 col-md-2 col-xs-6">
        <Alert type="info">Result Count - {total || iceBreakerList.length}</Alert>
      </div>
      <div className="black-list-table-pagination">
        <ServerSidePagination data={iceBreakerList} total={total} onPageNum={onPageNumberChange}>
          <TableCard loading={dataLoading} data={iceBreakerList} tableData={tableData} />
        </ServerSidePagination>
      </div>

      {iceBreakerList.length ? (
        <div className="col-12 col-md-2 col-xs-12 offset-md-10">
          <Alert type="info">Result Count - {total || iceBreakerList.length}</Alert>
        </div>
      ) : null}
    </Grid.Row>
  );
};

export default AutomationCategories;
